export const GlobalConstants = {
  //* General
  key: "-----BEGIN PUBLIC KEY-----\nMFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEEVs/o5+uQbTjL3chynL4wXgUg2R9\nq9UU8I5mEovUf86QZ7kOBIjJwqnzD1omageEHWwHdBO6B+dFabmdT9POxg==\n-----END PUBLIC KEY-----",
  alertSuccess: "success",
  alertWarning: "warning",
  alertError: "error",
  alertInfo: "info",
  urlImagenPlaceHolder:
    "https://www.agora-gallery.com/advice/wp-content/uploads/2015/10/image-placeholder.png",
  typeVisita: "VISITA",
  typeEntrega: "ENTREGA",

  // urlApi: "http://localhost:4000/api",
  // urlUploadImage: "http://localhost:4000/api/upload_files/",
  // urlUploadImage: 'https://maestros.amovil.co/api/upload_files/',
  // urlUploadImage: 'http://conector.amovil.co:43387/api/upload_files/',

  //* Maestros
  // urlApi: 'https://maestros.amovil.co/api',
  // urlApi: 'http://conector.amovil.co:43387/api',

  urlApi: "/api",
  urlUploadImage: "/api/upload_files/",
};
